import { Button } from '@bambi/component-library/src/components/Button/Button';
import { useCallback } from 'react';

import { adminActions } from '../admin.slice';
import { useAppDispatch } from 'src/app/store/hooks';

export function AliviSettingsRouteActions() {
  const dispatch = useAppDispatch();

  const handleAddAliviSettings = useCallback(() => {
    dispatch(adminActions.setShowAliviSettingsModal(true));
  }, [dispatch]);

  return (
    <div className="flex flex-row gap-2">
      <Button onClick={handleAddAliviSettings} variant="primary">
        Add Alivi Settings
      </Button>
    </div>
  );
}
